import { cn } from '../lib/cn';
import { Icon } from './icon';

/** Rotating indicator for short waits inside a control. Content areas use `Skeleton`. */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role={label ? 'status' : undefined} className="inline-flex">
      <Icon name="loader-circle" className={cn('animate-spin', className)} label={label} />
    </span>
  );
}
